import React from 'react';
import { Header } from '../../../components/ToxicDetector/Header';
import { HeroSection } from '../../../components/ToxicDetector/HeroSection';
import { TrustSection } from '../../../components/ToxicDetector/TrustSection';
import { FeaturesSection } from '../../../components/ToxicDetector/FeaturesSection';
import { GuaranteesSection } from '../../../components/ToxicDetector/GuaranteesSection';
import { ToolsSection } from '../../../components/ToxicDetector/ToolsSection';
import { ComparisonSection } from '../../../components/ToxicDetector/ComparisonSection';
import { PricingSection } from '../../../components/ToxicDetector/PricingSection';
import { FAQSection } from '../../../components/ToxicDetector/FAQSection';
import { CTASection } from '../../../components/ToxicDetector/CTASection';
import { Footer } from '../../../components/ToxicDetector/Footer';
import { MetaTags } from '../../../components/SEO/MetaTags';
import { PromoBanner } from '../../../components/Notifications/PromoBanner';
import { GoogleTranslateWidget } from '../../../components/GoogleTranslateWidget';
export function LandingPageJA() {
  const alternateUrls = [{
    lang: 'en',
    url: 'https://toxicdetector.com/'
  }, {
    lang: 'pt-BR',
    url: 'https://toxicdetector.com/pt/'
  }, {
    lang: 'es-MX',
    url: 'https://toxicdetector.com/es/'
  }, {
    lang: 'ja',
    url: 'https://toxicdetector.com/ja/'
  }, {
    lang: 'ko',
    url: 'https://toxicdetector.com/ko/'
  }, {
    lang: 'de',
    url: 'https://toxicdetector.com/de/'
  }, {
    lang: 'fr',
    url: 'https://toxicdetector.com/fr/'
  }, {
    lang: 'hi',
    url: 'https://toxicdetector.com/hi/'
  }, {
    lang: 'id',
    url: 'https://toxicdetector.com/id/'
  }];
  return <>
      <MetaTags title="ToxicDetector: AIによる関係分析 | 有害なパターンとガスライティングを検出" description="元パートナーが問題かどうかを調べましょう。チャットをToxicDetectorのAIにアップロードして、操作、ガスライティング、危険信号を即座に機密分析。今すぐ無料スキャンを開始。" keywords="AI関係分析, 有害なパターン検出, ガスライティング検出器, 有害な元パートナー, 操作チェック, 関係の毒性, AIテキストスキャナー" canonical="https://toxicdetector.com/ja" language="ja" alternateUrls={alternateUrls} data-id="element-7920" />
      <GoogleTranslateWidget data-id="element-7921" />
      <PromoBanner data-id="element-7922" />
      <div className="flex flex-col w-full min-h-screen bg-gradient-to-b from-stone-50 to-white" data-id="element-7923">
        <Header data-id="element-7924" />
        <main data-id="element-7925">
          <HeroSection h1Override={<>
                あなたの脳は{' '}
                <span className="relative inline-block" data-id="element-7927">
                  <span className="relative z-10 text-transparent bg-clip-text bg-gradient-to-b from-gray-200 to-gray-500" data-id="element-7928">
                    嘘
                  </span>
                  <span className="absolute top-1/2 left-0 w-full h-[4px] md:h-[6px] bg-[#FF0000] -translate-y-1/2 rotate-[-2deg]" data-id="element-7929" />
                </span>{' '}
                をついている。
                <br data-id="element-7930" />
                <span className="text-[#FF0000] drop-shadow-[0_0_30px_rgba(255,0,0,0.4)]" data-id="element-7931">
                  AIは嘘をつかない。
                </span>
              </>} data-id="element-7926" />
          <TrustSection data-id="element-7932" />
          <FeaturesSection data-id="element-7933" />
          <GuaranteesSection data-id="element-7934" />
          <ToolsSection data-id="element-7935" />
          <ComparisonSection data-id="element-7936" />
          <PricingSection data-id="element-7937" />
          <FAQSection data-id="element-7938" />
          <CTASection data-id="element-7939" />
        </main>
        <Footer data-id="element-7940" />
      </div>
    </>;
}